import { render } from "./inputSearch.vue?vue&type=template&id=194b7966&scoped=true&ts=true"
import script from "./inputSearch.vue?vue&type=script&lang=ts"
export * from "./inputSearch.vue?vue&type=script&lang=ts"

import "./inputSearch.vue?vue&type=style&index=0&id=194b7966&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194b7966"]])

export default __exports__